if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.prevButton = this.querySelector('.product-media-modal__prev');
        this.nextButton = this.querySelector('.product-media-modal__next');

        const handlePrev = (e) => {
          e.stopPropagation();
          e.preventDefault();
          this.navigate(-1);
        };

        const handleNext = (e) => {
          e.stopPropagation();
          e.preventDefault();
          this.navigate(1);
        };

        if (this.prevButton) {
          this.prevButton.addEventListener('click', handlePrev);
          this.prevButton.addEventListener('pointerup', (e) => {
            e.stopPropagation();
          });
        }

        if (this.nextButton) {
          this.nextButton.addEventListener('click', handleNext);
          this.nextButton.addEventListener('pointerup', (e) => {
            e.stopPropagation();
          });
        }

        window.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open')) return;
          if (event.code === 'ArrowLeft') {
            this.navigate(-1);
          } else if (event.code === 'ArrowRight') {
            this.navigate(1);
          }
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaItems = Array.from(this.querySelectorAll('.product-media-modal__content > *'));
        const targetMediaId = this.openedBy ? this.openedBy.getAttribute('data-media-id') : null;

        mediaItems.forEach((element) => element.classList.remove('active'));

        let activeMedia = targetMediaId ? this.querySelector(`[data-media-id="${targetMediaId}"]`) : null;
        if (!activeMedia && mediaItems.length > 0) {
          activeMedia = mediaItems[0];
        }

        if (activeMedia) {
          activeMedia.classList.add('active');
          const activeMediaTemplate = activeMedia.querySelector('template');
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
          if (
            activeMedia.nodeName === 'DEFERRED-MEDIA' &&
            activeMediaContent &&
            activeMediaContent.querySelector('.js-youtube')
          ) {
            activeMedia.loadContent();
          }
        }
      }

      navigate(direction) {
        const mediaItems = Array.from(this.querySelectorAll('.product-media-modal__content > *'));
        if (mediaItems.length <= 1) return;

        let currentIndex = mediaItems.findIndex((item) => item.classList.contains('active'));
        if (currentIndex === -1) currentIndex = 0;

        mediaItems[currentIndex].classList.remove('active');

        let nextIndex = (currentIndex + direction + mediaItems.length) % mediaItems.length;
        const nextMedia = mediaItems[nextIndex];
        nextMedia.classList.add('active');

        const activeMediaTemplate = nextMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        if (
          nextMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          nextMedia.loadContent();
        }
      }
    }
  );
}
